import { DocumentType } from '../type';
import { DocumentActionsEnum, DocumentDispatchType } from './actions';

export type DocumentReducerType = {
  isLoading: boolean;
  approved: {
    isLoading: boolean;
    refreshIndex: number;
    values: DocumentType[];
  };
  incorporated: {
    isLoading: boolean;
    refreshIndex: number;
    values: DocumentType[];
  };
  additional: {
    isLoading: boolean;
    refreshIndex: number;
    values: DocumentType[];
  };
  eugbrAdditional: {
    isLoading: boolean;
    refreshIndex: number;
    values: DocumentType[];
  };
  eugbrs: {
    isLoading: boolean;
    refreshIndex: number;
    values: DocumentType[];
  };
  eugbrComments: {
    isLoading: boolean;
    refreshIndex: number;
    values: DocumentType[];
  };
  cssf: {
    isLoading: boolean;
    values: DocumentType[];
  };
  translation: {
    isLoading: boolean;
    refreshIndex: number;
    values: DocumentType[];
  };
  certificateOfApproval: {
    isLoading: boolean;
    refreshIndex: number;
    values: DocumentType[];
  };
};

const initialState: DocumentReducerType = {
  isLoading: false,
  approved: {
    isLoading: false,
    refreshIndex: 0,
    values: [],
  },
  incorporated: {
    isLoading: false,
    refreshIndex: 0,
    values: [],
  },
  additional: {
    isLoading: false,
    refreshIndex: 0,
    values: [],
  },
  eugbrAdditional: {
    isLoading: false,
    refreshIndex: 0,
    values: [],
  },
  eugbrs: {
    isLoading: false,
    refreshIndex: 0,
    values: [],
  },
  eugbrComments: {
    isLoading: false,
    refreshIndex: 0,
    values: [],
  },
  cssf: {
    isLoading: false,
    values: [],
  },
  translation: {
    isLoading: false,
    refreshIndex: 0,
    values: [],
  },
  certificateOfApproval: {
    isLoading: false,
    refreshIndex: 0,
    values: [],
  },
};

const updateValuesWithItem = (documentsCategory: { values: DocumentType[] }, item: DocumentType) => {
  if (!documentsCategory.values) return [];

  if (!item.id || !documentsCategory.values.some((value: any) => value.id === item.id)) return [...documentsCategory.values];

  const lastIndex = documentsCategory.values.findIndex((value: any) => value.id === item.id);

  const newArray = [...documentsCategory.values];

  newArray[lastIndex] = item;

  return newArray;
};

const updateUploadStatusForItem = (documentsCategory: { values: DocumentType[] }, item: DocumentType) => {
  if (!documentsCategory.values) return [];

  if (!item.id || !documentsCategory.values.some((value: any) => value.id === item.id)) return [...documentsCategory.values];

  const lastIndex = documentsCategory.values.findIndex((value: any) => value.id === item.id);

  const newArray = [...documentsCategory.values];

  newArray[lastIndex].fileUploadStatus = item.fileUploadStatus;

  return newArray;
};

function reducerDocuments(state: DocumentReducerType = initialState, action: DocumentDispatchType): DocumentReducerType {
  switch (action.type) {
    case DocumentActionsEnum.DOCUMENT_APPROVED_FETCH: {
      return {
        ...state,
        approved: action.payload,
      };
    }

    case DocumentActionsEnum.DOCUMENT_EUGBR_FETCH: {
      return {
        ...state,
        eugbrs: action.payload,
      };
    }

    case DocumentActionsEnum.DOCUMENT_EUGBR_COMMENT_FETCH: {
      return {
        ...state,
        eugbrComments: action.payload,
      };
    }

    case DocumentActionsEnum.DOCUMENT_INCORPORATED_FETCH: {
      return {
        ...state,
        incorporated: action.payload,
      };
    }

    case DocumentActionsEnum.DOCUMENT_ADDITIONAL_FETCH: {
      return {
        ...state,
        additional: action.payload,
      };
    }

    case DocumentActionsEnum.DOCUMENT_EUGBR_ADDITIONAL_FETCH: {
      return {
        ...state,
        eugbrAdditional: action.payload,
      };
    }

    case DocumentActionsEnum.DOCUMENT_CSSF_FETCH: {
      return {
        ...state,
        cssf: action.payload,
      };
    }

    case DocumentActionsEnum.DOCUMENT_TRANSLATION_FETCH: {
      return {
        ...state,
        translation: {
          ...state.translation,
          ...action.payload,
        },
      };
    }

    case DocumentActionsEnum.DOCUMENT_TRANSLATION_REFRESH: {
      return {
        ...state,
        translation: {
          ...state.translation,
          refreshIndex: state.translation.refreshIndex + 1,
        },
      };
    }

    case DocumentActionsEnum.DOCUMENT_INCORPORATED_REFRESH: {
      return {
        ...state,
        incorporated: {
          ...state.incorporated,
          refreshIndex: state.incorporated.refreshIndex + 1,
        },
      };
    }

    case DocumentActionsEnum.DOCUMENT_APPROVED_REFRESH: {
      return {
        ...state,
        approved: {
          ...state.approved,
          refreshIndex: state.approved.refreshIndex + 1,
        },
      };
    }

    case DocumentActionsEnum.DOCUMENT_DOCUMENT_EUGBR_REFRESH: {
      return {
        ...state,
        eugbrs: {
          ...state.eugbrs,
          refreshIndex: state.eugbrs.refreshIndex + 1,
        },
      };
    }

    case DocumentActionsEnum.DOCUMENT_DOCUMENT_EUGBR_COMMENT_REFRESH: {
      return {
        ...state,
        eugbrComments: {
          ...state.eugbrComments,
          refreshIndex: state.eugbrComments.refreshIndex + 1,
        },
      };
    }

    case DocumentActionsEnum.DOCUMENT_DOCUMENT_EUGBR_ADDITIONAL_REFRESH: {
      return {
        ...state,
        eugbrAdditional: {
          ...state.eugbrAdditional,
          refreshIndex: state.eugbrAdditional.refreshIndex + 1,
        },
      };
    }

    case DocumentActionsEnum.DOCUMENT_ADDITIONAL_REFRESH: {
      return {
        ...state,
        additional: {
          ...state.additional,
          refreshIndex: state.additional.refreshIndex + 1,
        },
      };
    }

    case DocumentActionsEnum.DOCUMENT_EUGBR_ADDITIONAL_REFRESH: {
      return {
        ...state,
        eugbrAdditional: {
          ...state.eugbrAdditional,
          refreshIndex: state.eugbrAdditional.refreshIndex + 1,
        },
      };
    }

    case DocumentActionsEnum.DOCUMENT_FETCH:
    case DocumentActionsEnum.DOCUMENT_RESTORE:
      // If we received a value form the refresh action, update the table of values
      if (action.payload.values) {
        return {
          ...state,
          approved: {
            ...state.approved,
            values: updateValuesWithItem(state.approved, action.payload.values),
          },
          incorporated: {
            ...state.incorporated,
            values: updateValuesWithItem(state.incorporated, action.payload.values),
          },
          additional: {
            ...state.additional,
            values: updateValuesWithItem(state.additional, action.payload.values),
          },
          eugbrAdditional: {
            ...state.eugbrAdditional,
            values: updateValuesWithItem(state.eugbrAdditional, action.payload.values),
          },
          cssf: {
            ...state.cssf,
            values: updateValuesWithItem(state.cssf, action.payload.values),
          },
          translation: {
            ...state.translation,
            values: updateValuesWithItem(state.translation, action.payload.values),
          },
          certificateOfApproval: {
            ...state.certificateOfApproval,
            values: updateValuesWithItem(state.certificateOfApproval, action.payload.values),
          },
          eugbrComments: {
            ...state.eugbrComments,
            values: updateUploadStatusForItem(state.eugbrComments, action.payload.values),
          },
        };
      }
      return state;

    case DocumentActionsEnum.RESET_STATE:
      return initialState;

    default:
      return state;
  }
}
export default reducerDocuments;
